"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _5MLKOK3Fcjs = require('./5MLKOK3F.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/focus-trap/focus-trap.tsx
var TagName = "span";
var useFocusTrap = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFocusTrap2(props) {
    props = {
      "data-focus-trap": "",
      tabIndex: 0,
      "aria-hidden": true,
      ...props,
      style: {
        // Prevents unintended scroll jumps.
        position: "fixed",
        top: 0,
        left: 0,
        ...props.style
      }
    };
    props = _5MLKOK3Fcjs.useVisuallyHidden.call(void 0, props);
    return props;
  }
);
var FocusTrap = _PTOCUU2Dcjs.forwardRef.call(void 0, function FocusTrap2(props) {
  const htmlProps = useFocusTrap(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useFocusTrap = useFocusTrap; exports.FocusTrap = FocusTrap;
